import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    Table, TableBody,
    TableCell, TableContainer, TableHead,
    TableRow, Typography
} from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

class CustomTable extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        headerTitle: PropTypes.string.isRequired,
        headerIcon: PropTypes.element.isRequired,
        headings: PropTypes.arrayOf(PropTypes.node).isRequired,
        skeleton: PropTypes.bool
    };

    constructor (props) {
        super(props);
    }

    render () {
        const { classes, skeleton, headerTitle, headerIcon, headings, children } =this.props;

        if (skeleton) { return <Skeleton animation="wave" height={125} variant="rect" />; }

        return (
            <TableContainer classes={{ root: classes.tableContainerRoot }}>
                <Typography className={classes.tableTypography}>{headerIcon}{headerTitle}</Typography>
                <Table size="small" >
                    <TableHead classes={{ root: classes.tableHeadRoot }}>
                        <TableRow>
                            {headings.map((heading, idx) =>
                                <TableCell key={idx} classes={{ root: classes.tableCellRoot }} align={'left'}>
                                    {heading}
                                </TableCell>)
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {children}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    }
}

const style = theme => ({

    tableContainerRoot: {
        border: `1px solid ${theme.palette.background.border}`,
        borderRadius: theme.constants.radius.sm,
        boxSizing: 'border-box'
    },
    tableTypography: {
        padding: theme.constants.horizontalMargin,
        color: theme.palette.text.primary,
        display: 'flex',
        alignItems: 'center',
        '&> svg': {
            fontSize: '1.2em',
            marginRight: theme.constants.horizontalMargin
        }
    },
    tableHeadRoot: {
        borderTop: `1px solid ${theme.palette.background.border}`,
        background: `${theme.palette.grey.variant3}33`
    },
    tableCellRoot: {
        ...theme.typography.subtitle1,
        borderBottom: 'initial',
        padding: 0,
        height: theme.constants.tableRowHeight,
        '&:first-child': {
            paddingLeft: theme.constants.horizontalMargin
        },
        '&:last-child': {
            paddingRight: theme.constants.horizontalMargin
        }
    }
});

export default withStyles(style)(CustomTable);